// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline_headline__1WLDt","headline__content":"Headline_headline__content__2fMrx","headline__img":"Headline_headline__img__wIGxN"};